export const options = [
  'The SmartStart routine/session must last at least 3 hours.',
  'Playgroups can have a maximum of 12 children. Day mothers & ECD centres can have a maximum of 20 children per class.',
  'All programmes must have 1 adult for every 10 children.',
];
